/**
 * Notification Service (Frontend)
 * FindMyLawyer – Lawyer Portal
 *
 * Axios wrappers for all notification REST API endpoints.
 */

import { lawyerApi } from "./http";

const BASE = "/notifications";

// ── Fetch paginated notifications ─────────────────────────────────────────────
// Uses cursor pagination: pass { cursor, cursorId } from previous response.
export async function fetchNotifications({ status, type, cursor, cursorId, limit = 20 } = {}) {
  const params = { limit };
  if (status && status !== "ALL")  params.status   = status;
  if (type   && type   !== "ALL")  params.type     = type;
  if (cursor)                       params.cursor   = cursor;
  if (cursorId)                     params.cursorId = cursorId;

  const { data } = await lawyerApi.get(BASE, { params });
  return data; // { notifications, nextCursor, hasMore }
}

// ── Unread summary: count + latest 5 ─────────────────────────────────────────
export async function fetchUnreadSummary() {
  const { data } = await lawyerApi.get(`${BASE}/unread`);
  return data; // { count, notifications }
}

// ── Mark single as read ───────────────────────────────────────────────────────
export async function markAsRead(id) {
  const { data } = await lawyerApi.patch(`${BASE}/${id}/read`);
  return data;
}

// ── Soft delete (archive) ─────────────────────────────────────────────────────
export async function archiveNotification(id) {
  const { data } = await lawyerApi.patch(`${BASE}/${id}/archive`);
  return data;
}

// ── Mark all as read ──────────────────────────────────────────────────────────
export async function markAllRead() {
  const { data } = await lawyerApi.patch(`${BASE}/read-all`);
  return data;
}

// ── Preferences ───────────────────────────────────────────────────────────────
export async function fetchPreferences() {
  const { data } = await lawyerApi.get(`${BASE}/preferences`);
  return data;
}

export async function updatePreferences(preferences) {
  const { data } = await lawyerApi.patch(`${BASE}/preferences`, { preferences });
  return data;
}

// ── Dev: Seed all notification types ─────────────────────────────────────────
export async function seedNotifications() {
  const { data } = await lawyerApi.post(`${BASE}/seed`);
  return data;
}
